import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = {
  class: "p-field p-col p-col-12 p-md-12 p-lg-12",
  style: {"font-size":"13px"}
}
const _hoisted_3 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_4 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"13px"} }, "Mã y tế", -1)
const _hoisted_6 = {
  key: 0,
  class: "p-field p-col p-col-12 p-md-12 p-lg-12"
}
const _hoisted_7 = { class: "stream" }
const _hoisted_8 = { class: "p-field p-col p-col-6 p-md-3 p-lg-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"13px"} }, "Tra cứu", -1)
const _hoisted_10 = { class: "p-field p-col p-col-6 p-md-3 p-lg-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"13px"} }, "Quét mã bệnh nhân", -1)
const _hoisted_12 = {
  class: "p-field p-col p-col-12 p-md-12 p-lg-12",
  style: {"font-size":"13px"}
}
const _hoisted_13 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_14 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"13px"} }, "Mã y tế", -1)
const _hoisted_16 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"13px"} }, "Họ và tên", -1)
const _hoisted_18 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"13px"} }, "Ngày sinh", -1)
const _hoisted_20 = { class: "p-field p-col p-col-12 p-md-12 p-lg-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"13px"} }, "Địa chỉ thường trú", -1)
const _hoisted_22 = { class: "p-field p-col p-col-12 p-md-12 p-lg-6" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"13px"} }, "Chẩn đoán", -1)
const _hoisted_24 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_25 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_26 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_27 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_28 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}
const _hoisted_29 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_30 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_31 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_32 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_33 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}
const _hoisted_34 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_35 = { id: "loading" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", null, "Đang tra cứu thông tin ...", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputGroup = _resolveComponent("InputGroup")!
  const _component_StreamBarcodeReader = _resolveComponent("StreamBarcodeReader")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Panel, { header: "Tra cứu thông tin CLS của bệnh nhân" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_InputGroup, null, {
                default: _withCtx(() => [
                  _createVNode(_component_InputText, {
                    type: "text",
                    useGrouping: false,
                    id: "name",
                    placeholder: "Nhập mã bệnh nhân...",
                    modelValue: $setup.maYTe,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.maYTe) = $event)),
                    style: {"text-align":"center","font-size":"13px"},
                    onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => ($setup.loadListCls()), ["enter"]))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_Button, {
                    label: "Xóa",
                    icon: "pi pi-delete-left",
                    severity: "danger",
                    iconPos: "left",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.deleteData())),
                    style: {"font-size":"13px"}
                  })
                ]),
                _: 1
              })
            ]),
            ($setup.openCamera)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_StreamBarcodeReader, {
                      zoom: 3,
                      autofocus: true,
                      onDecode: $setup.onDecode,
                      onLoaded: $setup.onLoaded
                    }, null, 8, ["onDecode", "onLoaded"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_Button, {
                label: "Tìm",
                icon: "pi pi-search",
                iconPos: "left",
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.loadListCls())),
                style: {"font-size":"13px"}
              })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_Button, {
                label: "Quét mã",
                icon: "pi pi-barcode",
                severity: "warning",
                iconPos: "left",
                onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.scanBarcode())),
                style: {"font-size":"13px"}
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_12, [
      ($setup.listCLS.length > 0)
        ? (_openBlock(), _createBlock(_component_Panel, {
            key: 0,
            header: "Thông tin bệnh nhân"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_component_InputText, {
                    id: "maYTe",
                    type: "text",
                    modelValue: $setup.listCLS[0].mayte,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.listCLS[0].mayte) = $event)),
                    style: {"text-align":"center","font-size":"13px"},
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_InputText, {
                    id: "hoVaTen",
                    type: "text",
                    modelValue: $setup.listCLS[0].tenbenhnhan,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.listCLS[0].tenbenhnhan) = $event)),
                    style: {"text-align":"center","font-size":"13px"},
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode(_component_InputText, {
                    id: "ngaySinh",
                    modelValue: $setup.ngaySinh,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.ngaySinh) = $event)),
                    type: "text",
                    style: {"text-align":"center","font-size":"13px"},
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createVNode(_component_InputText, {
                    id: "diaChi",
                    type: "text",
                    modelValue: $setup.listCLS[0].diachithuongtru,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.listCLS[0].diachithuongtru) = $event)),
                    style: {"text-align":"center","font-size":"13px"},
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createVNode(_component_InputText, {
                    id: "chanDoan",
                    type: "text",
                    modelValue: $setup.listCLS[0].chandoan,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.listCLS[0].chandoan) = $event)),
                    style: {"text-align":"center","font-size":"13px"},
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createVNode(_component_Panel, { header: "Danh sách dịch vụ CLS chưa thực hiện" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_DataTable, {
                loading: $setup.isLoading,
                value: $setup.listCLSChuaThucHien,
                paginator: true,
                stripedRows: "",
                rows: 30,
                rowsPerPageOptions: [30,50,100],
                rowHover: true,
                filters: $setup.filters,
                "onUpdate:filters": _cache[12] || (_cache[12] = ($event: any) => (($setup.filters) = $event)),
                paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                globalFilterFields: ['tendichvu'],
                currentPageReportTemplate: "Có tổng số {totalRecords} dịch vụ CLS",
                columnResizeMode: "fit | expand"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_Button, {
                      type: "button",
                      icon: "pi pi-filter-slash",
                      label: "Xoá",
                      class: "p-button-outlined",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.clearFilter())),
                      style: {"width":"10em"}
                    }),
                    _createElementVNode("span", _hoisted_28, [
                      _createVNode(_component_InputText, {
                        modelValue: $setup.filters['global'].value,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.filters['global'].value) = $event)),
                        placeholder: "Tìm theo dịch vụ"
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    field: "tendichvu",
                    header: "Tên dịch vụ",
                    sortable: ""
                  }),
                  _createVNode(_component_Column, {
                    field: "ngaygioyeucau",
                    header: "Thời gian yêu cầu",
                    sortable: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString($setup.formatDateTime(slotProps.data.ngaygioyeucau)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "sophieuyeucau",
                    header: "Số phiếu",
                    sortable: ""
                  }),
                  _createVNode(_component_Column, {
                    field: "tenphongban",
                    header: "Nơi chỉ định",
                    sortable: ""
                  }),
                  _createVNode(_component_Column, {
                    field: "hientrang",
                    header: "Tình trạng",
                    sortable: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_Button, {
                        severity: "danger",
                        type: "button",
                        label: slotProps.data.hientrang
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["loading", "value", "filters"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createVNode(_component_Panel, {
        header: "Danh sách dịch vụ CLS Đã thực hiện",
        style: {"color":"#2196f3"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_DataTable, {
                loading: $setup.isLoading,
                value: $setup.listCLSDaThucHien,
                paginator: true,
                stripedRows: "",
                rows: 30,
                rowsPerPageOptions: [30,50,100],
                rowHover: true,
                filters: $setup.filters,
                "onUpdate:filters": _cache[15] || (_cache[15] = ($event: any) => (($setup.filters) = $event)),
                paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                globalFilterFields: ['tendichvu'],
                currentPageReportTemplate: "Có tổng số {totalRecords} dịch vụ CLS",
                columnResizeMode: "fit | expand"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_component_Button, {
                      type: "button",
                      icon: "pi pi-filter-slash",
                      label: "Xoá",
                      class: "p-button-outlined",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.clearFilter())),
                      style: {"width":"10em"}
                    }),
                    _createElementVNode("span", _hoisted_33, [
                      _createVNode(_component_InputText, {
                        modelValue: $setup.filters['global'].value,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.filters['global'].value) = $event)),
                        placeholder: "Tìm theo dịch vụ"
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    field: "tendichvu",
                    header: "Tên dịch vụ",
                    sortable: ""
                  }),
                  _createVNode(_component_Column, {
                    field: "ngaygioyeucau",
                    header: "Thời gian yêu cầu",
                    sortable: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString($setup.formatDateTime(slotProps.data.ngaygioyeucau)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "sophieuyeucau",
                    header: "Số phiếu",
                    sortable: ""
                  }),
                  _createVNode(_component_Column, {
                    field: "tenphongban",
                    header: "Nơi chỉ định",
                    sortable: ""
                  }),
                  _createVNode(_component_Column, {
                    field: "hientrang",
                    header: "Tình trạng",
                    sortable: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      (slotProps.data.trangthai == 'HOANTAT')
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            severity: "info",
                            label: slotProps.data.hientrang,
                            type: "button"
                          }, null, 8, ["label"]))
                        : (_openBlock(), _createBlock(_component_Button, {
                            key: 1,
                            severity: "warning",
                            label: slotProps.data.hientrang,
                            type: "button"
                          }, null, 8, ["label"]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["loading", "value", "filters"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createVNode(_component_Dialog, {
        header: "Đang tải dữ liệu",
        visible: $setup.loadingBar,
        "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => (($setup.loadingBar) = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createVNode(_component_ProgressBar, {
              mode: "indeterminate",
              style: {"height":".3em"}
            })
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_ConfirmDialog)
    ])
  ]))
}